import reportService from "@/services/report";

/**
 * Rezervni obroci (jela iz grupa): učitavanje koje se ponavlja i kad se promene firme (stari tab ga je ponavljao
 * samo pri promeni perioda) i ne preskače zahtev dok je prethodni u toku. Zahteva nasleđen stari tab
 * ReportMealsTabReservedMeals (companies, loading.fetchDailyMoreRestaurants, selectedMealCompanies, filters).
 */
export default {
  data: () => ({
    failed: false,
    requestId: 0,
  }),
  computed: {
    selectedKey() {
      return this.selectedMealCompanies.map((company) => company.id).join(",");
    },
  },
  watch: {
    selectedKey() {
      this.fetchDailyMoreRestaurants();
    },
  },
  methods: {
    async fetchDailyMoreRestaurants() {
      const requestId = ++this.requestId;
      this.failed = false;
      const companyIds = this.selectedMealCompanies.map((company) => company.id);
      if (!companyIds.length) {
        this.companies = [];
        this.loading.fetchDailyMoreRestaurants = false;
        return;
      }
      this.loading.fetchDailyMoreRestaurants = true;
      try {
        const response = await reportService.getReservedMealsV2(this.$store.state.restaurant.id, {
          date_from: this.filters.dates.from,
          date_to: this.filters.dates.to,
          company_ids: companyIds.join(","),
        });
        if (requestId === this.requestId) {
          this.companies = Array.isArray(response.data) ? response.data : [];
        }
      } catch (error) {
        if (requestId === this.requestId) {
          this.companies = [];
          this.failed = true;
        }
      } finally {
        if (requestId === this.requestId) {
          this.loading.fetchDailyMoreRestaurants = false;
        }
      }
    },
  },
};
